import { useNavigate } from "react-router-dom";
//import { RightImage } from "../images/Aboutus";
import {
  BusinessBenefits,
  EnterpriseCloud,
  TheChallenge,
  TheSolution,
  PolyTxlHero,
  PolyTxl,
  KeyFeatures,
} from "../../images";
import { Banner, AboutImage, BlueLarge } from "../../images/index";
import { useState, useEffect } from "react";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import useSlug from "../SlugComp";
import { getPagesBySlug } from "../../services/apiService";
import SEO from "../Seo";

function Products() {
  const navigate = useNavigate();
  const slug = useSlug();
  const [metaData, setMetaData] = useState({});
  const ldJsonSCript = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "PolyTXL",
    url: "https://techprojects.com/Products",
    description:
      "PolyTXL is a real-time, context-aware extension that dynamically translates tableau dashboard labels, filters, titles, tooltips and any text into multiple languages without duplicating or modifying existing workbooks.",
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Data Analytics Translation",
    operatingSystem: "Web, Tableau Server, Tableau Cloud, Tableau Public",
    softwareVersion: "1.0",
    featureList: [
      "Real-time context-aware translation of Tableau dashboards",
      "No dashboard duplication required",
      "Custom glossary and terminology management",
      "Website-controlled language selection",
      "In-line language selection",
      "Compatible with Tableau Server, Tableau Cloud, Tableau Public and embedded dashboards",
      "SaaS, cloud, on-prem, and fully hosted deployment options",
    ],
    publisher: {
      "@type": "Organization",
      name: "TechProjects",
      url: "https://www.techprojects.com",
      logo: {
        "@type": "ImageObject",
        url: "https://techprojects.com/logo.png",
      },
      contactPoint: {
        "@type": "ContactPoint",
        email: "polytxl@techprojects.com",
        contactType: "sales",
      },
      sameAs: ["https://www.linkedin.com/company/techprojects/"],
    },
    audience: {
      "@type": "Audience",
      audienceType: "Enterprise and Public Sector organizations using Tableau",
    },
    screenshot: {
      "@type": "ImageObject",
      url: "https://techprojects.com/images/polytxl-screenshot.png",
      description:
        "PolyTXL translating a Tableau dashboard into multiple languages in real time",
    },
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(ldJsonSCript);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };
    fetchData();
  }, []);

  useEffect(() => {});

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 left-0 right-0">
            <div className="max-w-lg font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  Products
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                PolyTXL
              </h1>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Deliver multilingual Tableau dashboards to every user — without
                duplicating or rebuilding a single report.
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                PolyTXL is a context-aware translation extension that translates
                dashboard labels, filters, titles, tooltips, and any text in
                real time based on each user's language preference. One
                workbook. Any language. Instant access.
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-[6rem]">
              {/* <img
                src={PolyTxlHero}
                alt="IT Hiring"
                className="w-full h-auto"
              /> */}
              <img src={PolyTxl} alt="PolyTXL Logo" className="object-cover" />
            </div>
          </div>
        </div>
        <section className="bg-white py-2 px-6 md:px-12 relative overflow-hidden font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div className="relative flex justify-center md:justify-start">
              <div className="absolute top-8 left-8 w-64 h-72 bg-red-500 rounded-[2rem] -z-10"></div>

              <img
                src={PolyTxlHero}
                alt="PolyTXL Logo"
                className="w-full h-auto"
              />
            </div>

            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                The Challenge
              </h2>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Why Multilingual Tableau Dashboards Are Hard to Scale
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Organizations using Tableau across global teams face a common
                bottleneck. Dashboards are built in one language, then manually
                translated or duplicated for each region. This approach
                multiplies maintenance effort, delays time-to-insight, and
                drives up operational costs especially at enterprise or
                public-sector scale.
              </p>
              {/* <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Designed for enterprise and public-sector environments,PolyTXL
                removes language barriers and makes analytics accessible to
                diverse user communities worldwide.
              </p> */}
            </div>
          </div>
        </section>
        <section className="bg-white py-8 md:py-16 md:px-0 px-6 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto flex flex-col gap-12">
            <div className="flex flex-col md:flex-row justify-between items-center md:items-center md:gap-10">
              <div>
                <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
                <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                  The Solution
                </h2>
                <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                  How PolyTXL for Tableau Works
                </h5>
                <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                  PolyTXL sits as a real-time translation layer between your
                  Tableau dashboard and your users. When a user selects their
                  language on your website, portal, or embedded app PolyTXL
                  dynamically translates all visible dashboard text without
                  touching the underlying report or data model.
                </p>
                <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                  One dashboard. Multiple languages. Zero redesign.
                </h5>
              </div>
              <div className="flex mt-6 md:mt-0">
                <img
                  src={TheChallenge}
                  alt="PolyTXL Logo"
                  className="object-cover"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-2 px-6 md:px-12 relative overflow-hidden font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div className="relative flex justify-center md:justify-start">
              <div className="absolute top-8 left-8 w-64 h-72 bg-red-500 rounded-[2rem] -z-10"></div>

              <img
                src={TheSolution}
                alt="PolyTXL Logo"
                className="object-cover"
              />
            </div>

            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] leading-tight mb-4">
                Key Features
              </h2>

              <ul className="space-y-4 text-[#404040] text-lg">
                <li>
                  • Real-Time, Context-Aware Translation – Translates dashboard
                  titles, labels, axis text, filters, and tooltips dynamically
                  as users switch languages.
                </li>
                <li>
                  • No Dashboard Duplication – Maintain a single Tableau
                  workbook for all languages; PolyTXL handles the rest.
                </li>
                <li>
                  • Natural Language Processing (NLP) and Machine Learning (ML)
                  based smart translation and filtering.
                </li>
                <li>
                  • Glossary-Based Consistency – Define business-specific
                  terminology once; PolyTXL applies it accurately across every
                  dashboard.
                </li>
                <li>
                  • Website-Controlled Language Selection – Embed language
                  preferences from your host application directly into dashboard
                  translations.
                </li>
                <li>
                  • In-line Language Selection - Enable in-line language
                  selection option within the dashboard.
                </li>
                <li>
                  • Flexible Deployment – Available as SaaS, cloud-hosted,
                  on-prem, or fully managed.
                </li>
              </ul>

              {/* <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                PolyTXL introduces a real-time translation layer that
                dynamically translates dashboard content based on user language
                selection while keeping the original dashboard unchanged. One
                dashboard. Multiple languages. Instant access.
              </p> */}
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="bg-white py-14 px-6 md:px-12 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>

              <h2 className="text-5xl font-extrabold text-[#434253] mb-6">
                Business Benefits
              </h2>

              <ul className="space-y-4 text-[#404040] text-lg">
                <li>
                  ✔ Eliminate manual translation and dashboard duplication
                  effort
                </li>
                <li>
                  ✔ Reduce maintenance costs across multilingual Tableau
                  deployments
                </li>
                <li>
                  ✔ Accelerate insight delivery for global and regional teams
                </li>
                <li>
                  ✔ Improve accessibility for diverse users in enterprise and
                  public-sector environments
                </li>
                <li>
                  ✔ Scale analytics across languages without adding workbook
                  complexity
                </li>
              </ul>
            </div>

            <div className="flex justify-center md:justify-end">
              <img
                src={KeyFeatures}
                alt="Key Features"
                className="rounded-2xl object-cover"
              />
            </div>
          </div>
        </section>

        {/* Business Benefits */}
        <section className="bg-white py-14 px-6 md:px-12 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div className="flex justify-center md:justify-start">
              <img
                src={BusinessBenefits}
                alt="PolyTXL Logo"
                className="rounded-2xl object-cover"
              />
            </div>

            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>

              <h2 className="text-5xl font-extrabold text-[#434253] mb-6">
                Enterprise-Ready and Secure
              </h2>

              <ul className="space-y-4 text-[#404040] text-lg">
                <li>
                  • Zero changes to existing Tableau dashboards or data sources
                </li>
                <li>
                  • Aligns with your existing Tableau Server / Cloud governance
                  and security model
                </li>
                <li>
                  • Smart, scalable translation that grows with your user base
                </li>
                <li>
                  • Seamless integration into embedded analytics, web portals,
                  and internal tools
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Enterprise and Cloud Ready */}
        <section className="bg-white py-14 px-6 md:px-12 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>

              <h2 className="text-5xl font-extrabold text-[#434253] mb-6">
                Frequently Asked Questions
              </h2>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Q1 : How is PolyTXL different from duplicating Tableau
                dashboards per language?
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Duplicating dashboards creates parallel maintenance — every
                change must be made in every copy. PolyTXL keeps a single
                source-of-truth dashboard and applies translations dynamically,
                so updates propagate instantly to all languages.
              </p>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Q2 : Does PolyTXL translate data values or just the dashboard
                UI?
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                PolyTXL focuses on dashboard UI text: titles, labels, filter
                names, axis text, tooltips and any visible text. Data values
                remain as sourced from your underlying database.
              </p>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Q3 : Can we use our own approved translations and glossaries?
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Yes. PolyTXL supports custom glossaries so you can lock in
                approved business terminology across every language and
                dashboard. You can also configure exclusion patterns and apply
                industry based contexts.
              </p>
              <h5 className="text-md md:text-md font-extrabold text-[#434253] leading-tight mb-4">
                Q4 : Does PolyTXL work with Tableau Server, Tableau Cloud,
                Tableau Public for embedded dashboards?
              </h5>
              <p className="text-lg font-400 text-[#404040] mb-6 leading-relaxed">
                Yes. PolyTXL is compatible with Tableau Server, Tableau Cloud,
                Tableau Public for dashboards embedded in web applications or
                portals.
              </p>
            </div>

            <div className="flex justify-center md:justify-end">
              <img
                src={EnterpriseCloud}
                alt="PolyTXL Logo"
                className="rounded-2xl object-cover"
              />
            </div>
          </div>
        </section>

        {/* Final section with CTA */}
        <section
          className="text-white flex items-center py-8 md:py-[4rem] relative overflow-hidden bg-cover bg-no-repeat font-roboto"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <h2 className="text-3xl md:text-4xl xl:text-6xl max-w-4xl mx-auto font-extrabold text-white leading-tight mb-[2rem] md:mb-[3rem]">
              Get Started with PolyTXL.
            </h2>
            <p className="text-lg font-400 text-[#CBD5E1] max-w-3xl  mx-auto">
              Enable multilingual analytics across your organization — without
              disrupting your existing Tableau environment.
            </p>
            <div className="w-full text-white py-3">
              <div className="max-w-[1200px] mx-auto flex items-center justify-center gap-16">
                <div className="flex items-center gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                    />
                  </svg>

                  <span className="text-lg">Contact us</span>
                </div>

                <div className="flex items-center gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                    />
                  </svg>

                  <span className="text-lg">
                    <a href="mailto:polytxl@techprojects.com">
                      polytxl@techprojects.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap  justify-center mt-10 gap-6 md:gap-12">
              <button
                // onClick={handleClick}
                type="submit"
                className="bg-activeColor text-white text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                <a href="mailto:polytxl@techprojects.com"> Request a Demo</a>
              </button>
            </div>
          </div>
        </section>

        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Products;
